module.exports = __webpack_public_path__ + "img/esm.f9d2c126.jpg";